import { ResizeObserver } from '@juggle/resize-observer';
import uro from 'use-resize-observer';

if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

export const useResizeObserver = uro;
